/**
 * Utility functions to prevent content copying/downloading
 */

/**
 * Disables right-click context menu, keyboard shortcuts, and drag events
 * for all images and videos on the page
 */
export const preventMediaDownload = () => {
  // Prevent right-click on images and videos
  document.addEventListener('contextmenu', (e) => {
    if (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO') {
      e.preventDefault();
      return false;
    }
  }, false);

  // Prevent dragging of images and videos
  document.addEventListener('dragstart', (e) => {
    if (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO') {
      e.preventDefault();
      return false;
    }
  }, false);

  // Prevent keyboard shortcuts for copying/saving
  document.addEventListener('keydown', (e) => {
    // Prevent Ctrl+S, Ctrl+U, Ctrl+P, Ctrl+Shift+I
    if ((e.ctrlKey || e.metaKey) &&
        (e.key === 's' || e.key === 'u' || e.key === 'p' ||
        (e.shiftKey && e.key === 'i'))) {
      e.preventDefault();
      return false;
    }
  }, false);
};

/**
 * Applies CSS to prevent selection and downloading of images and videos
 */
export const applyProtectionStyles = () => {
  // Create a style element
  const style = document.createElement('style');
  style.innerHTML = `
    img, video {
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -o-user-select: none;
      user-select: none;
      -webkit-user-drag: none;
      -khtml-user-drag: none;
      -moz-user-drag: none;
      -o-user-drag: none;
      pointer-events: none; /* Disables direct right-click on images */
    }
    
    .cloudinary-video-container video,
    .cloudinary-slider img,
    .gallery img {
      pointer-events: auto; /* Re-enable pointer events for controls */
      user-select: none; /* Prevent selection */
    }
  `;
  document.head.appendChild(style);
};
